import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { globalCtx } from "./Context.js";
import { equals, curry3, createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { Mobiscroll_inputOptions, Mbs_DatePicker } from "./Feliz.Mobiscroll.js";
import { isBig } from "./Utils.js";
import { singleton as singleton_1, ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { class_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { MuiHelpers_createElement } from "./fable_modules/Feliz.MaterialUI.5.13.7-alpha.5/Mui.fs.js";
import { ButtonGroup, TableBody, TableHead, Table as Table_1, TableRow, TableCell, TextField, Checkbox, FormControlLabel, IconButton, DialogActions, Button, DialogContentText, DialogContent, DialogTitle, Dialog } from "@mui/material";
import { EventLog, EventLog_create } from "./Shared/ApiDataTypes.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { map as map_1, defaultArg, value as value_78, some } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { wrapTooltip } from "./ViewHelpers.js";
import Cancel from "@mui/icons-material/Cancel";
import { compare, toShortDateString, utcNow } from "./fable_modules/fable-library-js.4.24.0/Date.js";
import { sortByDescending, map, find } from "./fable_modules/fable-library-js.4.24.0/Array.js";
import Edit from "@mui/icons-material/Edit";
import Delete from "@mui/icons-material/Delete";

export function DatePicker(datePickerInputProps) {
    let elems;
    const setValue = datePickerInputProps.setValue;
    const value = datePickerInputProps.value;
    const label = datePickerInputProps.label;
    const ctx = reactApi.useContext(globalCtx);
    return createElement("div", createObj(ofArray([["style", {
        width: 250,
    }], (elems = [Mbs_DatePicker([["controls", ["calendar"]], ["rangeStartLabel", "Start"], ["rangeEndLabel", "Slutt"], ["select", "date"], ["focusOnClose", false], ["value", value], ["onChange", (e) => {
        setValue(e.value);
    }], ["timeFormat", ""], ["dateFormat", "DD. MMMM YYYY"], ["inputProps", Mobiscroll_inputOptions([["inputStyle", "outline"], ["label", label]])], ["touchUi", !isBig(ctx.Responsive)]])], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export class DeleteDialog {
    constructor() {
    }
}

export function DeleteDialog_$reflection() {
    return class_type("ViewHelpers.EventLogs.DeleteDialog", undefined, DeleteDialog);
}

export function DeleteDialog_$ctor() {
    return new DeleteDialog();
}

export function DeleteDialog_View_B0AE7AA(deleteDialog_View_B0AE7AAInputProps) {
    let elements_2, elements, children;
    const onClose = deleteDialog_View_B0AE7AAInputProps.onClose;
    const onDelete = deleteDialog_View_B0AE7AAInputProps.onDelete;
    const isOpen = deleteDialog_View_B0AE7AAInputProps.isOpen;
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_3, v) => {
        onClose();
    }], ["PaperProps", {
        style: {
            padding: 10,
            maxWidth: 800,
            width: 90 + "vw",
            minWidth: 200,
        },
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", "Er du sikker på at du vil slette denne hendelsen?"]]), MuiHelpers_createElement(DialogContent, [["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elements = [MuiHelpers_createElement(DialogContentText, [["children", "Dette vil slette loggen permanent"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]), (children = ofArray([MuiHelpers_createElement(Button, [["onClick", (_arg_1) => {
        onClose();
    }], ["children", "Avbryt"]]), MuiHelpers_createElement(Button, [["color", "primary"], ["onClick", (_arg) => {
        onDelete();
    }], ["children", "Slett"]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

export class EditDialog {
    constructor() {
    }
}

export function EditDialog_$reflection() {
    return class_type("ViewHelpers.EventLogs.EditDialog", undefined, EditDialog);
}

export function EditDialog_$ctor() {
    return new EditDialog();
}

export function EditDialog_AddView_Z42F25CCA(editDialog_AddView_Z42F25CCAInputProps) {
    let elements_3, elements_1, elems_2, handler_4, eventLog_6, handler_5, eventLog_4, children_1;
    const onClose = editDialog_AddView_Z42F25CCAInputProps.onClose;
    const onAccept = editDialog_AddView_Z42F25CCAInputProps.onAccept;
    const isOpen = editDialog_AddView_Z42F25CCAInputProps.isOpen;
    let patternInput;
    const initial = EventLog_create();
    patternInput = reactApi.useState(initial);
    const setEventLog = patternInput[1];
    const eventLog = patternInput[0];
    const handleSetDueDateClick = (eventLog_5, dueDate_1, _arg_3) => {
        setEventLog(new EventLog(eventLog_5.Id, eventLog_5.Text, eventLog_5.ResponseText, eventLog_5.RegistrationDate, eventLog_5.Author, dueDate_1, eventLog_5.IsDone));
    };
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_4, v) => {
        onClose();
    }], ["PaperProps", {
        style: {
            padding: 10,
            maxWidth: 800,
            width: 90 + "vw",
            minWidth: 200,
        },
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", "Legg til hendelse"]]), MuiHelpers_createElement(DialogContent, [["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elements_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
    }], (elems_2 = toList(delay(() => {
        let eventLog_3;
        return append(singleton(createElement(DatePicker, {
            label: "Registreringsdato",
            value: eventLog.RegistrationDate,
            setValue: (eventLog_3 = eventLog, (_arg_2) => {
                if (_arg_2 != null) {
                    setEventLog(new EventLog(eventLog_3.Id, eventLog_3.Text, eventLog_3.ResponseText, _arg_2, eventLog_3.Author, eventLog_3.DueDate, eventLog_3.IsDone));
                }
                else {
                    console.error(some("Error when setting registration date! Try again later."));
                }
            }),
        })), delay(() => {
            let matchValue, dueDate_2, elems_1, elements, props_3, eventLog_2;
            return append((matchValue = eventLog.DueDate, (matchValue != null) ? ((dueDate_2 = matchValue, singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
            }], (elems_1 = [wrapTooltip("Fjern frist", MuiHelpers_createElement(IconButton, [["onClick", curry3(handleSetDueDateClick)(eventLog)(undefined)], ["size", "small"], (elements = [(props_3 = {}, react.createElement(Cancel, props_3))], ["children", reactApi.Children.toArray(Array.from(elements))])])), createElement(DatePicker, {
                label: "Frist",
                value: dueDate_2,
                setValue: (eventLog_2 = eventLog, (dueDate) => {
                    setEventLog(new EventLog(eventLog_2.Id, eventLog_2.Text, eventLog_2.ResponseText, eventLog_2.RegistrationDate, eventLog_2.Author, dueDate, eventLog_2.IsDone));
                }),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(MuiHelpers_createElement(Button, [["onClick", curry3(handleSetDueDateClick)(eventLog)(utcNow())], ["children", "Sett frist"]]))), delay(() => {
                let handler_3, eventLog_1;
                return singleton(MuiHelpers_createElement(FormControlLabel, [["label", "Utført"], ["checked", eventLog.IsDone], (handler_3 = ((eventLog_1 = eventLog, (isDone) => {
                    setEventLog(new EventLog(eventLog_1.Id, eventLog_1.Text, eventLog_1.ResponseText, eventLog_1.RegistrationDate, eventLog_1.Author, eventLog_1.DueDate, isDone));
                })), ["onChange", (e) => {
                    handler_3(e.target.checked);
                }]), ["control", MuiHelpers_createElement(Checkbox, [])]]));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), MuiHelpers_createElement(TextField, [["id", "event-text"], ["label", "Hendelse"], ["size", "small"], ["multiline", true], ["rows", 4], ["required", true], (handler_4 = ((eventLog_6 = eventLog, (text_1) => {
        setEventLog(new EventLog(eventLog_6.Id, text_1, eventLog_6.ResponseText, eventLog_6.RegistrationDate, eventLog_6.Author, eventLog_6.DueDate, eventLog_6.IsDone));
    })), ["onChange", (e_1) => {
        handler_4(e_1.target.value);
    }]), ["value", eventLog.Text]]), MuiHelpers_createElement(TextField, [["id", "event-resp-text"], ["label", "Oppfølging"], ["size", "small"], ["multiline", true], ["rows", 4], ["required", false], (handler_5 = ((eventLog_4 = eventLog, (text) => {
        setEventLog(new EventLog(eventLog_4.Id, eventLog_4.Text, text, eventLog_4.RegistrationDate, eventLog_4.Author, eventLog_4.DueDate, eventLog_4.IsDone));
    })), ["onChange", (e_2) => {
        handler_5(e_2.target.value);
    }]), ["value", eventLog.ResponseText]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), (children_1 = ofArray([MuiHelpers_createElement(Button, [["onClick", (_arg_1) => {
        onClose();
    }], ["children", "Avbryt"]]), MuiHelpers_createElement(Button, [["onClick", (_arg) => {
        setEventLog(EventLog_create());
        onAccept(eventLog);
    }], ["children", "Legg til"]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

export function EditDialog_UpdateView_23A296DF(editDialog_UpdateView_23A296DFInputProps) {
    let elements_3, elements_1, elems_2, handler_4, eventLog_6, handler_5, eventLog_4, children_1;
    const onClose = editDialog_UpdateView_23A296DFInputProps.onClose;
    const onAccept = editDialog_UpdateView_23A296DFInputProps.onAccept;
    const updating = editDialog_UpdateView_23A296DFInputProps.updating;
    let patternInput;
    const initial = EventLog_create();
    patternInput = reactApi.useState(initial);
    const setEventLog = patternInput[1];
    const eventLog = patternInput[0];
    const dependencies = [updating];
    reactApi.useEffect(() => {
        if (updating != null) {
            setEventLog(value_78(updating));
        }
    }, dependencies);
    const handleSetDueDateClick = (eventLog_5, dueDate_1, _arg_4) => {
        setEventLog(new EventLog(eventLog_5.Id, eventLog_5.Text, eventLog_5.ResponseText, eventLog_5.RegistrationDate, eventLog_5.Author, dueDate_1, eventLog_5.IsDone));
    };
    return MuiHelpers_createElement(Dialog, [["open", updating != null], ["onClose", (_arg_5, v) => {
        onClose();
    }], ["PaperProps", {
        style: {
            padding: 10,
            maxWidth: 800,
            width: 90 + "vw",
            minWidth: 200,
        },
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", "Oppdater hendelse"]]), MuiHelpers_createElement(DialogContent, [["style", {
        display: "flex",
        flexDirection: "column",
        gap: 15 + "px ",
    }], (elements_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
    }], (elems_2 = toList(delay(() => {
        let eventLog_3;
        return append(singleton(createElement(DatePicker, {
            label: "Registreringsdato",
            value: eventLog.RegistrationDate,
            setValue: (eventLog_3 = eventLog, (_arg_3) => {
                if (_arg_3 != null) {
                    setEventLog(new EventLog(eventLog_3.Id, eventLog_3.Text, eventLog_3.ResponseText, _arg_3, eventLog_3.Author, eventLog_3.DueDate, eventLog_3.IsDone));
                }
                else {
                    console.error(some("Error when setting registration date! Try again later."));
                }
            }),
        })), delay(() => {
            let matchValue, dueDate_2, elems_1, elements, props_3, eventLog_2;
            return append((matchValue = eventLog.DueDate, (matchValue != null) ? ((dueDate_2 = matchValue, singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
            }], (elems_1 = [wrapTooltip("Fjern frist", MuiHelpers_createElement(IconButton, [["onClick", curry3(handleSetDueDateClick)(eventLog)(undefined)], ["size", "small"], (elements = [(props_3 = {}, react.createElement(Cancel, props_3))], ["children", reactApi.Children.toArray(Array.from(elements))])])), createElement(DatePicker, {
                label: "Frist",
                value: dueDate_2,
                setValue: (eventLog_2 = eventLog, (dueDate) => {
                    setEventLog(new EventLog(eventLog_2.Id, eventLog_2.Text, eventLog_2.ResponseText, eventLog_2.RegistrationDate, eventLog_2.Author, dueDate, eventLog_2.IsDone));
                }),
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(MuiHelpers_createElement(Button, [["onClick", curry3(handleSetDueDateClick)(eventLog)(utcNow())], ["children", "Sett frist"]]))), delay(() => {
                let handler_3, eventLog_1;
                return singleton(MuiHelpers_createElement(FormControlLabel, [["label", "Utført"], ["checked", eventLog.IsDone], (handler_3 = ((eventLog_1 = eventLog, (isDone) => {
                    setEventLog(new EventLog(eventLog_1.Id, eventLog_1.Text, eventLog_1.ResponseText, eventLog_1.RegistrationDate, eventLog_1.Author, eventLog_1.DueDate, isDone));
                })), ["onChange", (e) => {
                    handler_3(e.target.checked);
                }]), ["control", MuiHelpers_createElement(Checkbox, [])]]));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), MuiHelpers_createElement(TextField, [["id", "event-text"], ["label", "Hendelse"], ["size", "small"], ["multiline", true], ["rows", 4], ["required", true], (handler_4 = ((eventLog_6 = eventLog, (text_1) => {
        setEventLog(new EventLog(eventLog_6.Id, text_1, eventLog_6.ResponseText, eventLog_6.RegistrationDate, eventLog_6.Author, eventLog_6.DueDate, eventLog_6.IsDone));
    })), ["onChange", (e_1) => {
        handler_4(e_1.target.value);
    }]), ["value", eventLog.Text]]), MuiHelpers_createElement(TextField, [["id", "event-resp-text"], ["label", "Oppfølging"], ["size", "small"], ["multiline", true], ["rows", 4], ["required", false], (handler_5 = ((eventLog_4 = eventLog, (text) => {
        setEventLog(new EventLog(eventLog_4.Id, eventLog_4.Text, text, eventLog_4.RegistrationDate, eventLog_4.Author, eventLog_4.DueDate, eventLog_4.IsDone));
    })), ["onChange", (e_2) => {
        handler_5(e_2.target.value);
    }]), ["value", eventLog.ResponseText]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), (children_1 = ofArray([MuiHelpers_createElement(Button, [["onClick", (_arg_1) => {
        onClose();
    }], ["children", "Avbryt"]]), MuiHelpers_createElement(Button, [["onClick", (_arg) => {
        onAccept(eventLog);
    }], ["children", "Legg til"]])]), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

function td$0027(c) {
    return MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", reactApi.Children.toArray(Array.from(c))]]);
}

const headers = (() => {
    const children = ofArray([MuiHelpers_createElement(TableCell, [["children", "Registrert"]]), MuiHelpers_createElement(TableCell, [["children", "Hendelse"]]), MuiHelpers_createElement(TableCell, [["children", "Oppfølging"]]), MuiHelpers_createElement(TableCell, [["children", "Frist"]]), MuiHelpers_createElement(TableCell, [["children", "Utført"]]), MuiHelpers_createElement(TableCell, [["children", "Forfatter"]]), MuiHelpers_createElement(TableCell, [["id", "event-log-table-action-column"]])]);
    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]);
})();

function findSelected(id, events) {
    return find((ev) => (ev.Id === id), events);
}

function commonRows(regDate, text, responseText, dueDate, isDone, author) {
    const xs_1 = [td$0027([regDate]), td$0027([text]), td$0027([responseText]), td$0027([dueDate]), td$0027([MuiHelpers_createElement(Checkbox, [["disabled", true], ["checked", isDone]])]), td$0027([createElement("span", {
        children: author,
    })])];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

export class Table {
    constructor() {
    }
}

export function Table_$reflection() {
    return class_type("ViewHelpers.EventLogs.Table", undefined, Table);
}

export function Table_$ctor() {
    return new Table();
}

export function Table_View_Z36B05FD5(table_View_Z36B05FD5InputProps) {
    let elements_1, elems_2;
    const events = table_View_Z36B05FD5InputProps.events;
    return MuiHelpers_createElement(Table_1, [["size", "small"], ["style", {
        width: 100 + "%",
    }], (elements_1 = [MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray([headers])]]), MuiHelpers_createElement(TableBody, [["style", {
        textAlign: "right",
    }], (elems_2 = map((eventLog) => {
        let elems;
        const author = defaultArg(map_1((a) => a.Name, eventLog.Author), "");
        const dueDate = defaultArg(map_1(toShortDateString, eventLog.DueDate), "Ingen");
        return MuiHelpers_createElement(TableRow, [(elems = [commonRows(toShortDateString(eventLog.RegistrationDate), eventLog.Text, eventLog.ResponseText, dueDate, eventLog.IsDone, author)], ["children", reactApi.Children.toArray(Array.from(elems))])]);
    }, sortByDescending((ev) => ev.RegistrationDate, events, {
        Compare: compare,
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]);
}

export function Table_View_336D8DAB(table_View_336D8DABInputProps) {
    let elements_4, elems_5;
    const onDelete = table_View_336D8DABInputProps.onDelete;
    const onUpdate = table_View_336D8DABInputProps.onUpdate;
    const events = table_View_336D8DABInputProps.events;
    return MuiHelpers_createElement(Table_1, [["style", {
        width: 100 + "%",
    }], (elements_4 = [MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray([headers])]]), MuiHelpers_createElement(TableBody, [["style", {
        textAlign: "right",
    }], (elems_5 = [map((eventLog_2) => {
        let elems_3, children_2, elements, props_1, elements_1, props_4;
        const author = defaultArg(map_1((a) => a.Name, eventLog_2.Author), "");
        const dueDate = defaultArg(map_1(toShortDateString, eventLog_2.DueDate), "Ingen");
        return MuiHelpers_createElement(TableRow, [(elems_3 = [commonRows(toShortDateString(eventLog_2.RegistrationDate), eventLog_2.Text, eventLog_2.ResponseText, dueDate, eventLog_2.IsDone, author), td$0027([(children_2 = ofArray([MuiHelpers_createElement(IconButton, [["onClick", (_arg_1) => {
            onUpdate(eventLog_2);
        }], (elements = [(props_1 = {}, react.createElement(Edit, props_1))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
            onDelete(eventLog_2);
        }], (elements_1 = [(props_4 = {}, react.createElement(Delete, props_4))], ["children", reactApi.Children.toArray(Array.from(elements_1))])])]), MuiHelpers_createElement(ButtonGroup, [["children", reactApi.Children.toArray(Array.from(children_2))]]))])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]);
    }, sortByDescending((ev) => ev.RegistrationDate, events, {
        Compare: compare,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
}

export function Table_View_7BCFB262(table_View_7BCFB262InputProps) {
    let elements, elements_8, elems_10;
    const onDelete = table_View_7BCFB262InputProps.onDelete;
    const onAccept = table_View_7BCFB262InputProps.onAccept;
    const onUpdate = table_View_7BCFB262InputProps.onUpdate;
    const events = table_View_7BCFB262InputProps.events;
    const ctx = reactApi.useContext(globalCtx);
    const patternInput = reactApi.useState(undefined);
    const setSelected = patternInput[1];
    const selected = patternInput[0];
    let userName;
    const matchValue = ctx.Session;
    if (matchValue == null) {
        console.error(some("not logged in"));
        userName = "";
    }
    else {
        userName = matchValue.Username;
    }
    const acceptCriteria = defaultArg(map_1((Id) => (findSelected(Id, events).Text === ""), selected), false);
    const deleteCriteria = defaultArg(map_1((Id_2) => {
        const e$0027_1 = findSelected(Id_2, events);
        return false;
    }, selected), false);
    const editButtons = MuiHelpers_createElement(ButtonGroup, [["orientation", "vertical"], (elements = [MuiHelpers_createElement(Button, [["disabled", acceptCriteria], ["onClick", (_arg) => {
        if (selected != null) {
            onAccept(findSelected(selected, events));
            setSelected(undefined);
        }
    }], ["children", "Godta"]]), MuiHelpers_createElement(Button, [["color", "secondary"], ["disabled", deleteCriteria], ["onClick", (_arg_1) => {
        if (selected != null) {
            onDelete(findSelected(selected, events).Id);
        }
    }], ["children", "Slett"]])], ["children", reactApi.Children.toArray(Array.from(elements))])]);
    return MuiHelpers_createElement(Table_1, [["style", {
        width: 100 + "%",
    }], (elements_8 = [MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray([headers])]]), MuiHelpers_createElement(TableBody, [["style", {
        textAlign: "right",
    }], (elems_10 = [map((ev_1) => {
        let elems_8, children, children_1, children_2, children_3, children_4, elems;
        if (equals(ev_1.Id, selected)) {
            const eventLog_2 = ev_1;
            const author_1 = defaultArg(map_1((a_1) => a_1.Name, eventLog_2.Author), userName);
            return MuiHelpers_createElement(TableRow, [["style", {
                backgroundColor: "#9A9A9A",
            }], (elems_8 = [(children = singleton_1(createElement(DatePicker, {
                label: "",
                value: eventLog_2.RegistrationDate,
                setValue: (date$0027_1) => {
                    if (date$0027_1 != null) {
                        const d = date$0027_1;
                        onUpdate(selected, (e_2) => (new EventLog(e_2.Id, e_2.Text, e_2.ResponseText, d, e_2.Author, e_2.DueDate, e_2.IsDone)));
                    }
                    else {
                        console.error(some("EventLogTable RegistrationDate change no value"));
                    }
                },
            })), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = singleton_1(MuiHelpers_createElement(TextField, [["id", "event-text"], ["onChange", (e_6) => {
                const text$0027_1 = e_6.target.value;
                onUpdate(selected, (e_4) => (new EventLog(e_4.Id, text$0027_1, e_4.ResponseText, e_4.RegistrationDate, e_4.Author, e_4.DueDate, e_4.IsDone)));
            }], ["size", "small"], ["multiline", true], ["value", eventLog_2.Text]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_2 = singleton_1(MuiHelpers_createElement(TextField, [["id", "event-resp-text"], ["onChange", (e_7) => {
                const text$0027 = e_7.target.value;
                onUpdate(selected, (e_3) => (new EventLog(e_3.Id, e_3.Text, text$0027, e_3.RegistrationDate, e_3.Author, e_3.DueDate, e_3.IsDone)));
            }], ["size", "small"], ["multiline", true], ["value", eventLog_2.ResponseText]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_2))]])), (children_3 = toList(delay(() => {
                const matchValue_1 = eventLog_2.DueDate;
                if (matchValue_1 != null) {
                    const dueDate_1 = matchValue_1;
                    return singleton(createElement(DatePicker, {
                        label: "",
                        value: dueDate_1,
                        setValue: (date$0027) => {
                            onUpdate(selected, (e) => (new EventLog(e.Id, e.Text, e.ResponseText, e.RegistrationDate, e.Author, date$0027, e.IsDone)));
                        },
                    }));
                }
                else {
                    return singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_3) => {
                        onUpdate(selected, (e_5) => (new EventLog(e_5.Id, e_5.Text, e_5.ResponseText, e_5.RegistrationDate, e_5.Author, utcNow(), e_5.IsDone)));
                    }], ["children", "Sett frist"]]));
                }
            })), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_3))]])), (children_4 = singleton_1(MuiHelpers_createElement(Checkbox, [["onChange", (e_8) => {
                const done$0027 = e_8.target.checked;
                onUpdate(selected, (e_1) => (new EventLog(e_1.Id, e_1.Text, e_1.ResponseText, e_1.RegistrationDate, e_1.Author, e_1.DueDate, done$0027)));
            }], ["checked", eventLog_2.IsDone]])), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray(Array.from(children_4))]])), MuiHelpers_createElement(TableCell, [["children", author_1]]), MuiHelpers_createElement(TableCell, [["children", reactApi.Children.toArray([editButtons])]])], ["children", reactApi.Children.toArray(Array.from(elems_8))])]);
        }
        else {
            const eventLog_1 = ev_1;
            const author = defaultArg(map_1((a) => a.Name, eventLog_1.Author), "");
            const dueDate = defaultArg(map_1(toShortDateString, eventLog_1.DueDate), "Ingen");
            return MuiHelpers_createElement(TableRow, [["onClick", (_arg_2) => {
                setSelected(eventLog_1.Id);
            }], (elems = [commonRows(toShortDateString(eventLog_1.RegistrationDate), eventLog_1.Text, eventLog_1.ResponseText, dueDate, eventLog_1.IsDone, author), MuiHelpers_createElement(TableCell, [])], ["children", reactApi.Children.toArray(Array.from(elems))])]);
        }
    }, sortByDescending((ev) => ev.RegistrationDate, events, {
        Compare: compare,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])], ["children", reactApi.Children.toArray(Array.from(elements_8))])]);
}

//# sourceMappingURL=EventLogs.js.map
